/** Configuración de runtime del frontend del operador, inyectada por Vite en build. */
export const config = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  ambiente: import.meta.env.VITE_AMBIENTE ?? 'dev',
  /**
   * Template con `{slug}` para armar la URL del portal de cada institución
   * (doc 06 §1.4), ej. "https://{slug}.instructor.intikipu.cl". Vacío en dev
   * (sin dominio wildcard) — ahí no se muestra el enlace, solo el slug.
   */
  portalUrlTemplate: import.meta.env.VITE_PORTAL_URL_TEMPLATE ?? '',
};

export function configCompleta(): boolean {
  return Boolean(config.userPoolId && config.clientId && config.apiUrl);
}
